import React from "react";
import { Badge, createStyles } from "@mantine/core";

interface ClientBadgeProps {
  clientName: string;
}

const useStyles = createStyles(() => ({
  badge: {
    textTransform: "none",
    fontWeight: 500,
    backgroundColor: "#FFF0ED",
    color: "#E8604C",
    border: "1px solid #FDDDD7",
  },
}));

const ClientBadge: React.FC<ClientBadgeProps> = ({ clientName }) => {
  const { classes } = useStyles();
  return (
    <Badge size="sm" className={classes.badge}>
      {clientName}
    </Badge>
  );
};

export default ClientBadge;
